<div class="d-flex align-items-center">
  <cap-button
    [styleClass]="to?.styleClass"
    [icon]="to?.icon"
    [label]="to?.textLabel"
    [disabled]="to?.disabled"
    (onClick)="to?.onClickCallback()">
  </cap-button>
</div>
